import request from '@/service/lib/request'

/**
 * 获取视频播放地址
 * @param {String} url 请求地址
 */
export function uploader(body) {
  let formData = new FormData()
  for (let key in body) {
    formData.append(key, body[key])
  }

  return request({
    url: `/api/admin/uploader`,
    method: 'POST',
    data: formData
  })
}
